import React from 'react'
import SearchInfoSidebar from './SearchInfoSidebar';

export default function Information() { 
  return (
        <SearchInfoSidebar/>
  )
}
